// extracted by mini-css-extract-plugin
export default {"elements":"Tp0fAJ","input":"e6b51p","button":"Phbbup","checkIcon":"Wf57ZO","submittedMessageContainer":"znow4p"};